<template>
  <div>
    <div class="card w-50">
      <div class="card-body">
        <h2 class="card-title">{{ name }}</h2>
        <a href="#" class="btn btn-primary" @click="selectIdPage(id)"
          >Ver Conteúdos</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    id: Number,
  },
  methods: {
    selectIdPage(idValue) {
      this.$router.push({
        name: "content",
        params: { id: idValue },
      });
    },
  },
};
</script>
<style scoped>
.card {
  margin: 0 auto;
  float: none;
  margin-top: 10px;
  background: #f5f7fa;
  box-shadow: 0 3px 5px #f7951ea8, 0 0 3px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  border: none;
}
</style>
